export const TRANSLATION_PT_BR = {
  titleHome: 'Vendas',
  captionHome: 'Nova venda',

  progress: {
    first: 'Home',
    second: 'Cliente',
    third: 'Anexar arquivo',
    fourth: 'Pagamentos',
    fifth: 'Contrato',
  },

  total: {
    title: 'Subtotal',
  },

  findClient: {
    title: 'Buscar cliente',
    findClient: 'Buscar cliente',
    select: 'Selecione',
    noOption: 'Nenhuma opção',
    buttonFetch: 'Buscar',
    buttonAdd: 'Adicionar Pessoa',
    buttonAtt: 'Atualizar',
    name: 'Nome completo',
    issuingBody: 'Órgão emissor',
    telephone: 'Telefone',
    cellPhone: 'Celular',
    dateOfBirth: 'Data de nascimento',
    nationality: 'Nascionalidade',
    stateOfBirth: 'Estado de nascimento',
    cityOfBirth: 'Naturalidade (Cidade de nascimento)',
    maritalStatus: 'Estado civil',
    gender: 'Sexo',
  },

  attachFile: {
    title: 'Anexar arquivos',
    info: 'Arraste para dentro ou <strong>clique</strong> para selecionar um arquivo',
    description: 'Formatos suportados: PDF, Word,  JPG, XLS e PNG',
  },

  buttonContinue: 'Continuar',
  buttonBack: 'Voltar',
  buttonDelete: 'Excluir',

  modal: {
    title: 'Tem certeza que deseja excluir este arquivo?',
    description: 'As mudanças serão salvas e a ação não poderá ser desfeita.',
  },

  modalAcknowledgment: {
    title: 'Opss!!',
    description:
      'O restante do fluxo está em desenvolvimento e em breve estará disponível para utilização.',
  },

  calendar: {
    january: 'Janeiro',
    february: 'Fevereiro',
    march: 'Março',
    april: 'Abril',
    may: 'Maio',
    june: 'Junho',
    july: 'Julho',
    august: 'Agosto',
    september: 'Setembro',
    october: 'Outubro',
    november: 'Novembro',
    december: 'Dezembro',
  },

  cleanForm: 'Limpar formulário',
}
